export default function Snackbar() {
  return (
    <div className="bg-yellow py-4 text-center">
      <p className="text-background text-xs md:text-base font-semibold">
        Build whatever your imagination creates
      </p>
    </div>
  );
}
